import { faAddressBook, faBuildingColumns, faSection } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, List, ListItemButton, ListItemIcon, ListItemText, useTheme } from "@vapor/react-material";
import { ExtendedTypography } from "@vapor/react-extended";
import { useEffect, useState } from "react";

interface SidebarDemoProps {
    list: string[];
    active: string;
    setActive: React.SetStateAction<any>;
}

export const SidebarDemo: React.FC<SidebarDemoProps> = ({ list, active, setActive }) => {
    const theme = useTheme();
    const icons = {
        banks: faBuildingColumns,
        sectionals: faSection,
        csl: faAddressBook
    };

    const labels = {
        banks: "Banche",
        sectionals: "Sezionali",
        csl: "CSL"
    };

    const [docHeight, setDocHeight] = useState(0);

    useEffect(() => {
        if (document.body.scrollHeight > window.innerHeight) {
            setDocHeight(document.body.scrollHeight);
        } else {
            setDocHeight(window.innerHeight - 48);
        }
    }, []);

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: 420,
                bgcolor: theme.palette.primary.background,
                minHeight: docHeight ?? "100vh"
            }}
            py={4}
            pl={8}
            pr={4}
        >
            <ExtendedTypography component={"div"} variant="titleLarge" gutterBottom mb={3}>
                Demo Components
            </ExtendedTypography>
            <List disablePadding>
                {list.map(item => {
                    const icon = icons[item];
                    return (
                        <ListItemButton
                            key={item}
                            selected={active === item}
                            onClick={() => setActive(item)}
                            sx={{
                                background: theme.palette.primary.background,
                                "&:hover": {
                                    background: `${theme.palette.primary.background} !important`
                                },
                                "&.Mui-selected": {
                                    background: theme.palette.primary.interactiveSelectedColor
                                },
                                "&:hover.Mui-selected": {
                                    background: `${theme.palette.primary.interactiveSelectedColor} !important`
                                }
                            }}
                        >
                            <ListItemIcon sx={{ justifyContent: "center", mr: 1 }}>
                                <FontAwesomeIcon icon={icon} />
                            </ListItemIcon>
                            <ListItemText primary={labels[item]} />
                        </ListItemButton>
                    );
                })}
            </List>
        </Box>
    );
};
